export const cities = {
  tacoma: {
    slug: 'tacoma-real-estate-agent',
    name: 'Tacoma',
    county: 'Pierce County',
    lat: 47.2529,
    lng: -122.4443,
    title: 'Tacoma Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      "Looking to buy or sell a home in Tacoma, WA? Mazen El-Majzoub is a top-rated Tacoma real estate agent with deep roots in Pierce County. Call (253) 315-9480.",
    headline: 'Tacoma Real Estate Agent',
    intro:
      "I grew up in Tacoma. I know these neighborhoods the way only someone who learned to drive on South Tacoma Way can. Whether you're buying your first home in North End, upgrading in Proctor, or selling an investment property in Hilltop, I bring local knowledge that Zillow can't give you.",
    neighborhoods: [
      'North End', 'Proctor', 'Stadium District', 'Hilltop',
      'Old Town', 'North Slope', 'West End', 'South Tacoma',
      'University Place border', 'Ruston'
    ],
    highlights: [
      'Pierce County native — 20+ years in Tacoma',
      'Expertise in Craftsman, Mid-Century, and New Construction inventory',
      'Strong relationships with local lenders, inspectors, and contractors',
      'Deep knowledge of Tacoma Public Schools boundaries',
    ],
    whyHere:
      "Tacoma's market moves fast. Median home prices continue to climb as buyers priced out of Seattle look south. I help clients move quickly without overpaying, and I help sellers position their homes to attract the right buyers at the right price. Every offer I write includes local insight most agents miss.",
    heroImage:
      'https://images.unsplash.com/photo-1587653263995-422546a7a569?w=1600&q=80',
  },

  seattle: {
    slug: 'seattle-real-estate-agent',
    name: 'Seattle',
    county: 'King County',
    lat: 47.6062,
    lng: -122.3321,
    title: 'Seattle Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Buying or selling in Seattle? Mazen El-Majzoub is a trusted Seattle real estate agent serving King County with expertise in every neighborhood. Call (253) 315-9480.',
    headline: 'Seattle Real Estate Agent',
    intro:
      "Seattle is not one market — it's dozens of them. A Ballard craftsman, a Queen Anne condo, and a West Seattle view home each demand different strategy. I've guided clients through purchases and sales across the city, and I know how to navigate King County's competitive offer environment.",
    neighborhoods: [
      'Ballard', 'Queen Anne', 'Capitol Hill', 'Fremont',
      'West Seattle', 'Magnolia', 'Green Lake', 'Wallingford',
      'Beacon Hill', 'Columbia City', 'Rainier Valley', 'Madrona'
    ],
    highlights: [
      'Experience negotiating in multi-offer Seattle markets',
      'Knowledge of Seattle condo associations and HOA dynamics',
      'Waterfront, view property, and historic home expertise',
      'Strong network of Seattle-area inspectors and lenders',
    ],
    whyHere:
      "Seattle buyers need an agent who understands escalation clauses, pre-inspections, and how to win in a bidding war without overpaying. Sellers need someone who knows how to price a home that's neither undervalued nor sitting on the market. I bring both.",
    heroImage:
      'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=1600&q=80',
  },

  lakewood: {
    slug: 'lakewood-real-estate-agent',
    name: 'Lakewood',
    county: 'Pierce County',
    lat: 47.1717,
    lng: -122.5185,
    title: 'Lakewood Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Looking for a Lakewood WA real estate agent? Mazen El-Majzoub offers local expertise in Lakewood homes, JBLM relocations, and Pierce County properties. (253) 315-9480.',
    headline: 'Lakewood Real Estate Agent',
    intro:
      "My office is in Lakewood. I work with families relocating in and out of Joint Base Lewis-McChord, first-time buyers looking for value south of Tacoma, and sellers who want to price their Lakewood home to actually move. Local market, local broker, local results.",
    neighborhoods: [
      'Tillicum', 'Lakewood Center', 'Oakbrook', 'Gravelly Lake',
      'American Lake', 'Steilacoom border', 'Custer', 'Springbrook'
    ],
    highlights: [
      'Office located at 4928 109th St SW, Lakewood',
      'JBLM military relocation experience',
      'VA loan transaction expertise',
      'Knowledge of Clover Park School District boundaries',
    ],
    whyHere:
      "Lakewood offers strong value for buyers priced out of Tacoma proper, with lake access, larger lots, and proximity to JBLM. For sellers, the right pricing and marketing reach into both local and Seattle-area buyer pools. I know what sells in Lakewood because I work it every day.",
    heroImage:
      'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1600&q=80',
  },

  'federal-way': {
    slug: 'federal-way-real-estate-agent',
    name: 'Federal Way',
    county: 'King County',
    lat: 47.3223,
    lng: -122.3126,
    title: 'Federal Way Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Federal Way real estate agent serving buyers and sellers in King County. Mazen El-Majzoub brings local expertise and tireless negotiation. Call (253) 315-9480.',
    headline: 'Federal Way Real Estate Agent',
    intro:
      "Federal Way sits at the perfect midpoint between Seattle and Tacoma — and buyers know it. I help clients take advantage of Federal Way's value while navigating a market that moves as fast as King County's northern cities.",
    neighborhoods: [
      'Twin Lakes', 'Dash Point', 'Redondo', 'Mirror Lake',
      'West Campus', 'Lakota', 'Camelot', 'North Lake'
    ],
    highlights: [
      'Federal Way Public Schools zoning knowledge',
      'Waterfront and lakefront property experience',
      'Strong buyer pool from Seattle commuters seeking value',
      'Commuter-focused market strategy (I-5, Sound Transit)',
    ],
    whyHere:
      "Federal Way buyers want price-per-square-foot that Seattle can't offer, without giving up Puget Sound access. Sellers benefit from a deep buyer pool of Seattle commuters willing to move south. I position both sides to win.",
    heroImage:
      'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1600&q=80',
  },

  auburn: {
    slug: 'auburn-real-estate-agent',
    name: 'Auburn',
    county: 'King County',
    lat: 47.3073,
    lng: -122.2285,
    title: 'Auburn Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Auburn WA real estate agent. Mazen El-Majzoub helps buyers and sellers across Auburn, Lea Hill, and South King County. Call (253) 315-9480 for a free consultation.',
    headline: 'Auburn Real Estate Agent',
    intro:
      "Auburn offers the best of South King County — strong schools, accessible pricing, room to breathe. I help first-time buyers break into the market here and sellers maximize value in Lea Hill, West Hill, and downtown Auburn neighborhoods.",
    neighborhoods: [
      'Lea Hill', 'West Hill', 'Downtown Auburn', 'Lakeland Hills',
      'North Auburn', 'Muckleshoot area', 'Pacific border'
    ],
    highlights: [
      'Auburn School District and Dieringer School District knowledge',
      'Experience with Lakeland Hills new construction',
      'First-time home buyer specialist',
      'Closed single-family transactions in Auburn (2024)',
    ],
    whyHere:
      "I've closed homes in Auburn and I know what buyers there care about — commute to Seattle, school zones, lot size, and fair pricing. My Auburn clients consistently beat out competing offers without overpaying.",
    heroImage:
      'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  puyallup: {
    slug: 'puyallup-real-estate-agent',
    name: 'Puyallup',
    county: 'Pierce County',
    lat: 47.1854,
    lng: -122.2929,
    title: 'Puyallup Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Puyallup real estate agent with local expertise in South Hill, downtown Puyallup, and Pierce County. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Puyallup Real Estate Agent',
    intro:
      "Puyallup is a family town with a strong, stable market. I help clients navigate the split between new-construction Lipoma Firs and established neighborhoods near downtown, matching the right home to the right lifestyle.",
    neighborhoods: [
      'South Hill', 'Downtown Puyallup', 'Edgewood border', 'Summit',
      'Lipoma Firs', 'Fruitland', 'Waller', 'North Hill'
    ],
    highlights: [
      'Puyallup School District zoning expertise',
      'New-construction transaction experience',
      'Knowledge of South Hill HOAs and developments',
      'Commuter strategy for Puyallup to Tacoma and Seattle',
    ],
    whyHere:
      "Puyallup's combination of good schools, reasonable pricing, and community feel drives steady demand. I help sellers position homes to attract that demand and buyers write competitive offers that actually win.",
    heroImage:
      'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },

  kent: {
    slug: 'kent-real-estate-agent',
    name: 'Kent',
    county: 'King County',
    lat: 47.3809,
    lng: -122.2348,
    title: 'Kent Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Kent WA real estate agent serving East Hill, West Hill, and the Kent Valley. Mazen El-Majzoub brings local market knowledge and proven results. (253) 315-9480.',
    headline: 'Kent Real Estate Agent',
    intro:
      "Kent spans from industrial valley to hilltop residential — three distinct markets in one city. I navigate all of them, from Panther Lake starter homes to East Hill family properties to West Hill view lots.",
    neighborhoods: [
      'East Hill', 'West Hill', 'Panther Lake', 'Lake Meridian',
      'Downtown Kent', 'Benson', 'North Kent', 'Clark Lake'
    ],
    highlights: [
      'Kent School District and Federal Way District knowledge',
      'Experience with Lake Meridian waterfront properties',
      'Industrial-adjacent residential transaction experience',
      'Strong buyer pool from South King commuters',
    ],
    whyHere:
      "Kent's price-per-square-foot beats most of King County, and East Hill in particular offers buyers a lot for the money. I know how to find the right home in the right pocket, and how to sell one without leaving money on the table.",
    heroImage:
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=80',
  },

  renton: {
    slug: 'renton-real-estate-agent',
    name: 'Renton',
    county: 'King County',
    lat: 47.4829,
    lng: -122.2171,
    title: 'Renton Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Renton real estate agent with deep knowledge of Highlands, Kennydale, and South Renton. Mazen El-Majzoub. Call (253) 315-9480 to buy or sell with confidence.',
    headline: 'Renton Real Estate Agent',
    intro:
      "Renton sits at the intersection of South King County value and Eastside opportunity — close to Bellevue, close to Seattle, with pricing that still works. I help clients buy before prices climb further, and sell when the market is ready.",
    neighborhoods: [
      'Renton Highlands', 'Kennydale', 'South Renton', 'Benson Hill',
      'Talbot Hill', 'West Hill', 'Newcastle border', 'Maplewood'
    ],
    highlights: [
      'Renton School District and Issaquah District coverage',
      'Kennydale waterfront and view property experience',
      'Proximity to Bellevue employers drives strong buyer demand',
      'Knowledge of Boeing-adjacent commute patterns',
    ],
    whyHere:
      "Renton gets the Eastside employer pool without Eastside prices. For buyers, that's a window. For sellers, it's a market with deep demand. I make sure my clients see both sides clearly.",
    heroImage:
      'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  bellevue: {
    slug: 'bellevue-real-estate-agent',
    name: 'Bellevue',
    county: 'King County',
    lat: 47.6101,
    lng: -122.2015,
    title: 'Bellevue Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Bellevue real estate agent serving buyers and sellers in Somerset, Bridle Trails, Clyde Hill, and downtown Bellevue. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Bellevue Real Estate Agent',
    intro:
      "Bellevue is a precision market. A $50k pricing mistake in Somerset or Bridle Trails can cost a seller weeks on market. I bring the discipline and local data to get it right — for buyers navigating Microsoft-backed demand, and sellers maximizing high-value properties.",
    neighborhoods: [
      'Downtown Bellevue', 'Somerset', 'Bridle Trails', 'Lake Hills',
      'Newport Shores', 'Meydenbauer', 'Eastgate', 'Factoria',
      'Clyde Hill border', 'Medina border'
    ],
    highlights: [
      'Bellevue School District — highest-demand schools in the state',
      'Experience with luxury homes and high-value listings',
      'Knowledge of Bellevue tech-employer buyer patterns',
      'Network of Bellevue-area lenders, inspectors, and attorneys',
    ],
    whyHere:
      "Bellevue buyers are sharp, well-financed, and often competitive. Bellevue sellers can't afford pricing errors. I bring the same rigor to a $3M Bridle Trails listing as I do to a $700k Eastgate starter — because every transaction here moves on data, not emotion.",
    heroImage:
      'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },
  'university-place': {
    slug: 'university-place-real-estate-agent',
    name: 'University Place',
    county: 'Pierce County',
    lat: 47.2354,
    lng: -122.5504,
    title: 'University Place Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      "University Place WA real estate agent with local expertise in Chambers Bay, Sunset Terrace, and Day Island. Mazen El-Majzoub. Call (253) 315-9480.",
    headline: 'University Place Real Estate Agent',
    intro:
      "University Place is where Tacoma professionals go when they want space, good schools, and Puget Sound views. I know the pockets that hold value and the ones that overpay — and I help my clients buy and sell on the right side of that line.",
    neighborhoods: ['Chambers Bay', 'Sunset Terrace', 'Day Island', 'Regents Park', 'Lakewold', 'Bridgeport'],
    highlights: [
      'University Place School District specialist',
      'Chambers Bay / golf course property experience',
      'View home and waterfront transaction knowledge',
      'Strong buyer demand from Tacoma and JBLM families',
    ],
    whyHere:
      "U.P. sits between Tacoma's affordability and Gig Harbor's premium — a sweet spot for buyers who want more than Tacoma offers without Gig Harbor's prices. I help clients read that balance correctly.",
    heroImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80',
  },

  fircrest: {
    slug: 'fircrest-real-estate-agent',
    name: 'Fircrest',
    county: 'Pierce County',
    lat: 47.2346,
    lng: -122.5157,
    title: 'Fircrest Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Fircrest WA real estate agent. Mazen El-Majzoub specializes in this tight-knit Pierce County community. Call (253) 315-9480 to buy or sell in Fircrest.',
    headline: 'Fircrest Real Estate Agent',
    intro:
      "Fircrest is small, tight, and in demand. Homes move fast here when priced right — and sit when they're not. I know the Fircrest buyer pool and how to reach it, whether you're selling a mid-century rambler or buying into the community.",
    neighborhoods: ['Central Fircrest', 'Fircrest Golf Course area', 'Emerson Street', 'Orchard Street', 'Alameda border'],
    highlights: [
      'Fircrest / University Place School District knowledge',
      'Experience with small-town Pierce County transactions',
      'Access to local inventory before it hits MLS',
      'Strong community knowledge through local relationships',
    ],
    whyHere:
      "Fircrest's compact footprint means every listing matters. I position sellers to catch the steady stream of buyers looking for this specific community, and help buyers move fast when inventory appears.",
    heroImage: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1600&q=80',
  },

  ruston: {
    slug: 'ruston-real-estate-agent',
    name: 'Ruston',
    county: 'Pierce County',
    lat: 47.3046,
    lng: -122.5057,
    title: 'Ruston Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      "Ruston WA real estate agent. Mazen El-Majzoub knows Point Ruston, Stack Hill, and Tacoma's waterfront jewel. Call (253) 315-9480.",
    headline: 'Ruston Real Estate Agent',
    intro:
      "Ruston is one square mile of some of the best waterfront real estate in Puget Sound. Whether it's a Point Ruston condo or a Stack Hill view home, I understand what drives value here and what separates a good deal from a great one.",
    neighborhoods: ['Point Ruston', 'Stack Hill', 'Ruston Way', 'Historic Ruston'],
    highlights: [
      'Point Ruston condo and HOA expertise',
      'Waterfront and view property transaction experience',
      'Knowledge of historic Ruston zoning and lot nuances',
      'Strong buyer network for high-end Tacoma-area properties',
    ],
    whyHere:
      "Ruston properties are scarce and specific. Pricing a Ruston home — or buying one — requires comps and context you can't get from a national portal. I bring the local depth this market needs.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  'pierce-county': {
    slug: 'pierce-county-real-estate-agent',
    name: 'Pierce County',
    county: 'Pierce County',
    lat: 47.0379,
    lng: -122.0,
    title: 'Pierce County Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Pierce County real estate agent covering Tacoma, Lakewood, Puyallup, University Place, Gig Harbor, Bonney Lake and more. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Pierce County Real Estate Agent',
    intro:
      "Pierce County is my home base. From Tacoma waterfront to Lakewood family homes to Puyallup new construction to Gig Harbor retirements — I cover the entire county. My office is in Lakewood, and I work every corner of Pierce.",
    neighborhoods: [
      'Tacoma', 'Lakewood', 'Puyallup', 'University Place',
      'Fircrest', 'Ruston', 'Gig Harbor', 'Bonney Lake',
      'Sumner', 'Edgewood', 'Fife', 'DuPont'
    ],
    highlights: [
      'Pierce County native — grew up in Tacoma',
      'Office located in Lakewood',
      'JBLM relocation and VA loan expertise',
      'Coverage across every major Pierce County city and town',
    ],
    whyHere:
      "Pierce County offers the widest price range and lifestyle variety in the South Sound. I help clients buy and sell across that entire range, matching the right property to the right goals.",
    heroImage: 'https://images.unsplash.com/photo-1685841295958-2695cbed9093?w=1600&q=80',
  },

  'king-county': {
    slug: 'king-county-real-estate-agent',
    name: 'King County',
    county: 'King County',
    lat: 47.5480,
    lng: -121.9836,
    title: 'King County Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'King County real estate agent serving Seattle, Bellevue, Kent, Renton, Federal Way, Auburn, and more. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'King County Real Estate Agent',
    intro:
      "King County is a massive, fragmented market — from $3M Bellevue properties to entry-level Kent homes to Seattle condos. I work every corner, with deep experience in both the Eastside and South King submarkets.",
    neighborhoods: [
      'Seattle', 'Bellevue', 'Kent', 'Renton',
      'Federal Way', 'Auburn', 'Des Moines', 'Normandy Park',
      'West Seattle', 'Burien', 'SeaTac'
    ],
    highlights: [
      'Extensive King County transaction history',
      'Eastside (Bellevue, Renton) and South King specialist',
      'Experience with luxury, mid-market, and first-time buyer segments',
      'Network of King County lenders, inspectors, and escrow officers',
    ],
    whyHere:
      "King County rewards agents who understand its submarkets. A Bellevue approach fails in Kent; a Kent approach fails in Capitol Hill. I know which levers to pull where.",
    heroImage: 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=1600&q=80',
  },

  'normandy-park': {
    slug: 'normandy-park-real-estate-agent',
    name: 'Normandy Park',
    county: 'King County',
    lat: 47.4393,
    lng: -122.3421,
    title: 'Normandy Park Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Normandy Park WA real estate agent. Mazen El-Majzoub closed a Normandy Park single-family home in 2025 — he knows this market. Call (253) 315-9480.',
    headline: 'Normandy Park Real Estate Agent',
    intro:
      "Normandy Park is quiet, well-kept, and highly sought after by South King buyers who want space and Puget Sound proximity. I closed a Normandy Park home in 2025 and I know how this specific market moves.",
    neighborhoods: ['Marine View Drive', 'Normandy Cove', 'Manhattan Village', '1st Avenue South corridor'],
    highlights: [
      '2025 closing: single-family home in Normandy Park',
      'Highline School District knowledge',
      'Waterfront and view home transaction experience',
      'Strong buyer pool from Seattle commuters seeking space',
    ],
    whyHere:
      "Normandy Park attracts buyers who've been priced out of West Seattle but still want the feel. That demand is consistent — pricing correctly captures it. I help sellers do exactly that.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  'des-moines': {
    slug: 'des-moines-real-estate-agent',
    name: 'Des Moines',
    county: 'King County',
    lat: 47.4015,
    lng: -122.3243,
    title: 'Des Moines Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Des Moines WA real estate agent. Marina views, waterfront condos, and South King homes. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Des Moines Real Estate Agent',
    intro:
      "Des Moines has a marina, a waterfront, and a compact residential core — plus some of the best value-per-view in South King County. I help buyers find the right spot along the hillside and sellers reach the marina-oriented buyer pool.",
    neighborhoods: ['Des Moines Marina', 'Des Moines Creek', 'Redondo', 'Woodmont Beach', 'Zenith'],
    highlights: [
      'Marina and waterfront property expertise',
      'Highline School District knowledge',
      'SeaTac proximity and airport-commuter strategy',
      'Experience with Des Moines condo associations',
    ],
    whyHere:
      "Des Moines is a buyer's value play and a seller's view story. I know how to tell each side the right thing — so buyers don't overpay and sellers don't underprice.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },

  'west-seattle': {
    slug: 'west-seattle-real-estate-agent',
    name: 'West Seattle',
    county: 'King County',
    lat: 47.5707,
    lng: -122.3866,
    title: 'West Seattle Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'West Seattle real estate agent with expertise in Alki, Admiral, Gatewood, and the Junction. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'West Seattle Real Estate Agent',
    intro:
      "West Seattle is its own world — craftsman homes with skyline views, Alki beach condos, and quiet pockets most people never find. I know what sells here and what sits, and I help my clients navigate the bridge-dependent market dynamics other agents ignore.",
    neighborhoods: ['Alki', 'Admiral', 'The Junction', 'Gatewood', 'Arbor Heights', 'High Point', 'Fauntleroy', 'Delridge'],
    highlights: [
      'Craftsman, mid-century, and new construction experience',
      'Alki waterfront and condo transactions',
      'Understanding of West Seattle Bridge buyer psychology',
      'Knowledge of Seattle Public Schools boundaries in WS',
    ],
    whyHere:
      "West Seattle pricing swings more than most Seattle neighborhoods — view premiums, commute anxieties, and distinct sub-market dynamics. I bring the local read that makes those swings work for you, not against.",
    heroImage: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=80',
  },

  'bonney-lake': {
    slug: 'bonney-lake-real-estate-agent',
    name: 'Bonney Lake',
    county: 'Pierce County',
    lat: 47.1773,
    lng: -122.1637,
    title: 'Bonney Lake Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Bonney Lake WA real estate agent. Lake access, mountain views, new construction. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Bonney Lake Real Estate Agent',
    intro:
      "Bonney Lake is where Pierce County buyers go for space, views, and lake access. New construction is strong here, and established neighborhoods offer lots that Tacoma can't. I help clients weigh both sides.",
    neighborhoods: ['Lake Tapps', 'Tehaleh', 'Eastridge', 'Rhodes Lake', 'Downtown Bonney Lake', 'Sumner border'],
    highlights: [
      'Lake Tapps waterfront experience',
      'Tehaleh master-planned community knowledge',
      'Sumner-Bonney Lake School District expertise',
      'New construction and builder-negotiation experience',
    ],
    whyHere:
      "Bonney Lake keeps growing, and pricing keeps adjusting. Smart buyers get in before the next wave; smart sellers read the comps correctly. I help both.",
    heroImage: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=1600&q=80',
  },

  olympia: {
    slug: 'olympia-real-estate-agent',
    name: 'Olympia',
    county: 'Thurston County',
    lat: 47.0379,
    lng: -122.9007,
    title: 'Olympia Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Olympia WA real estate agent serving the state capital. Mazen El-Majzoub helps buyers and sellers across Thurston County. Call (253) 315-9480.',
    headline: 'Olympia Real Estate Agent',
    intro:
      "Olympia is Washington's capital and an increasingly popular destination for buyers moving south from Pierce County. I know how Olympia differs from Tacoma — different commute patterns, different buyer expectations, different value signals.",
    neighborhoods: ['Downtown Olympia', 'West Olympia', 'South Capitol', 'Eastside', 'Tumwater border', 'Lacey border', 'Boston Harbor'],
    highlights: [
      'Thurston County market knowledge',
      'State employee and government-adjacent buyer experience',
      'Olympia School District zoning expertise',
      'Historic home and character property transactions',
    ],
    whyHere:
      "Olympia rewards patience and local insight. I help out-of-area buyers avoid the common mistakes and help local sellers position for the capital's stable, steady demand.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  lacey: {
    slug: 'lacey-real-estate-agent',
    name: 'Lacey',
    county: 'Thurston County',
    lat: 47.0343,
    lng: -122.8232,
    title: 'Lacey Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Lacey WA real estate agent. New construction, family neighborhoods, Thurston County expertise. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Lacey Real Estate Agent',
    intro:
      "Lacey is growing fast — new construction, family-focused neighborhoods, and strong schools. I help buyers separate real value from builder marketing, and sellers time the market right in a community that's still actively expanding.",
    neighborhoods: ['Hawks Prairie', 'Meridian Campus', 'Panorama', 'Horizon Pointe', 'Downtown Lacey', 'Thornbury', 'Northeast Lacey'],
    highlights: [
      'North Thurston School District knowledge',
      'New construction negotiation experience',
      'Hawks Prairie submarket expertise',
      'JBLM and Olympia commuter dynamics',
    ],
    whyHere:
      "Lacey's new construction volume means buyers need someone who negotiates builder contracts, not just accepts them. I do that — and I help sellers of existing homes compete effectively against new builds.",
    heroImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80',
  },

  'gig-harbor': {
    slug: 'gig-harbor-real-estate-agent',
    name: 'Gig Harbor',
    county: 'Pierce County',
    lat: 47.3293,
    lng: -122.5826,
    title: 'Gig Harbor Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      "Gig Harbor real estate agent. Waterfront, view homes, retirement buyers. Mazen El-Majzoub. Call (253) 315-9480.",
    headline: 'Gig Harbor Real Estate Agent',
    intro:
      "Gig Harbor is one of Pierce County's premier waterfront markets — a working harbor town that's grown into a destination for retirees, second-home buyers, and professionals crossing the Narrows Bridge. Pricing is higher than most of Pierce, but views and water access are why buyers pay it.",
    neighborhoods: ['Downtown Gig Harbor', 'Canterwood', 'Peninsula', 'Point Fosdick', 'Crescent Valley', 'Rosedale', 'Fox Island'],
    highlights: [
      'Waterfront and view property experience',
      'Peninsula School District knowledge',
      'Canterwood gated community transactions',
      'Strong retirement and second-home buyer demand',
    ],
    whyHere:
      "Gig Harbor rewards patience and local insight. Waterfront inventory is limited and pricing varies dramatically by view and water access. I help clients avoid overpaying while recognizing the value drivers specific to this market.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  sumner: {
    slug: 'sumner-real-estate-agent',
    name: 'Sumner',
    county: 'Pierce County',
    lat: 47.2037,
    lng: -122.2268,
    title: 'Sumner Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Sumner WA real estate agent. Small-town charm, family homes, Sumner-Bonney Lake Schools. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Sumner Real Estate Agent',
    intro:
      "Sumner is a small, family-oriented Pierce County city with genuine downtown character and strong schools. It offers value to buyers who want space and community without Puyallup or Bonney Lake pricing.",
    neighborhoods: ['Downtown Sumner', 'Alderton', 'Lakeland Division', 'Bonney Lake border', 'Orting Valley view lots'],
    highlights: [
      'Sumner-Bonney Lake School District',
      'Downtown Sumner historic charm',
      'Close commute to Auburn and Puyallup',
      'Affordable entry point vs neighboring cities',
    ],
    whyHere:
      "Sumner homes move at a steady, not frantic pace. Pricing here stays tight — good for buyers seeking value, fair for sellers who price correctly.",
    heroImage: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=80',
  },

  edgewood: {
    slug: 'edgewood-real-estate-agent',
    name: 'Edgewood',
    county: 'Pierce County',
    lat: 47.2470,
    lng: -122.2937,
    title: 'Edgewood Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Edgewood WA real estate agent. Large lots, semi-rural feel, close to I-5. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Edgewood Real Estate Agent',
    intro:
      "Edgewood is for buyers who want larger lots, semi-rural pacing, and easy freeway access. It sits between Puyallup and Federal Way, drawing families who prioritize space over walkability.",
    neighborhoods: ['Jovita Heights', 'Meridian corridor', 'Mountain View', 'Edgewood Commons area'],
    highlights: [
      'Puyallup and Fife School District coverage',
      'Larger lots than most Pierce County suburbs',
      'I-5 and Highway 161 access',
      'Quiet residential character',
    ],
    whyHere:
      "Edgewood attracts buyers who want room to grow — extra bedrooms, shop space, room for pets. Pricing is stable and turnover slower, which suits long-term buyers.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  fife: {
    slug: 'fife-real-estate-agent',
    name: 'Fife',
    county: 'Pierce County',
    lat: 47.2370,
    lng: -122.3593,
    title: 'Fife Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Fife WA real estate agent. Commuter sweet spot between Tacoma and Seattle. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Fife Real Estate Agent',
    intro:
      "Fife sits at the Pierce County gateway to I-5 and SR-167 — ideal for buyers commuting to Seattle, Tacoma, or the Kent Valley. The city mixes newer residential developments with long-established neighborhoods.",
    neighborhoods: ['Fife Heights', 'Brookville Gardens', 'Radiance', 'Milton border'],
    highlights: [
      'Fife School District — small, tight-knit',
      'Best-in-Pierce commute access to Seattle and Kent',
      'New construction inventory from national builders',
      'Industrial-adjacent residential — price-per-square-foot advantage',
    ],
    whyHere:
      "Fife runs below Tacoma median pricing for comparable floor plans. For commuters, the math works. I help clients navigate the new-build vs resale tradeoffs specific to this market.",
    heroImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80',
  },

  dupont: {
    slug: 'dupont-real-estate-agent',
    name: 'DuPont',
    county: 'Pierce County',
    lat: 47.0976,
    lng: -122.6335,
    title: 'DuPont Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'DuPont WA real estate agent. Northwest Landing master-planned community, JBLM-adjacent. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'DuPont Real Estate Agent',
    intro:
      "DuPont is a master-planned small city — Northwest Landing dominates the residential inventory — and a JBLM-adjacent favorite. Walkable town center, parks, and consistent architecture make it popular with military families and retirees.",
    neighborhoods: ['Northwest Landing', 'Hoffman Hill', 'Palisade', 'Historic DuPont'],
    highlights: [
      'Steilacoom Historical School District',
      'JBLM gate proximity — major VA loan market',
      'Master-planned community with walkable amenities',
      'Strong resale demand from military relocations',
    ],
    whyHere:
      "DuPont inventory is predictable but tight. Military relocation cycles drive consistent turnover. VA loan experience matters here — sellers familiar with VA timelines close more efficiently.",
    heroImage: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=1600&q=80',
  },

  spanaway: {
    slug: 'spanaway-real-estate-agent',
    name: 'Spanaway',
    county: 'Pierce County',
    lat: 47.1043,
    lng: -122.4336,
    title: 'Spanaway Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Spanaway WA real estate agent. Affordable Pierce County entry point, JBLM-adjacent. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Spanaway Real Estate Agent',
    intro:
      "Spanaway offers some of the most accessible pricing in Pierce County — large swaths of unincorporated land, newer subdivisions, and strong JBLM-related buyer demand. It's a first-time buyer and military family favorite.",
    neighborhoods: ['Brookdale', 'Spanaway Lake', 'Parkland border', 'Elk Plain'],
    highlights: [
      'Bethel School District',
      'JBLM and VA loan expertise',
      'Lower entry price vs Lakewood or Tacoma',
      'Spanaway Lake recreation access',
    ],
    whyHere:
      "Spanaway rewards buyers willing to look past aesthetics for value. New construction is strong here; so is the rental investor pool. I help owner-occupants avoid overpaying against investor competition.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },

  graham: {
    slug: 'graham-real-estate-agent',
    name: 'Graham',
    county: 'Pierce County',
    lat: 47.0529,
    lng: -122.2940,
    title: 'Graham Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Graham WA real estate agent. Rural Pierce County, large lots, acreage. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Graham Real Estate Agent',
    intro:
      "Graham offers something increasingly rare in Pierce County — acreage. Buyers looking for room for horses, shops, or just breathing space head here. Many homes qualify for USDA financing given the rural designation.",
    neighborhoods: ['Kapowsin', 'Frederickson border', 'Roy corridor', 'Elk Plain south'],
    highlights: [
      'Bethel School District',
      'USDA-eligible financing on many properties',
      'Acreage, horse properties, and shop-friendly lots',
      'Affordable vs urban Pierce',
    ],
    whyHere:
      "Graham buyers want land, not amenities. Water, septic, and well considerations matter here. I help clients assess total cost-of-ownership on rural properties — not just purchase price.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  steilacoom: {
    slug: 'steilacoom-real-estate-agent',
    name: 'Steilacoom',
    county: 'Pierce County',
    lat: 47.1704,
    lng: -122.6010,
    title: 'Steilacoom Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Steilacoom WA real estate agent. Historic waterfront town, tight inventory. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Steilacoom Real Estate Agent',
    intro:
      "Steilacoom is Washington's oldest incorporated town — a waterfront pocket with historic charm, top schools, and rarely-available inventory. It's a premium address for buyers who find the right home at the right moment.",
    neighborhoods: ['Old Town Steilacoom', 'Waterfront', 'Hilltop Steilacoom', 'JBLM-adjacent'],
    highlights: [
      'Steilacoom Historical School District — among the best in Pierce',
      'Waterfront and ferry-access views',
      'Historic homes, many on the registry',
      'JBLM proximity',
    ],
    whyHere:
      "Steilacoom inventory is thin. Homes that come up attract immediate attention. I help clients move quickly when the right home appears, and help sellers position homes to match the community's premium perception.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  issaquah: {
    slug: 'issaquah-real-estate-agent',
    name: 'Issaquah',
    county: 'King County',
    lat: 47.5301,
    lng: -122.0326,
    title: 'Issaquah Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Issaquah real estate agent. Highlands, top schools, tech employer demand. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Issaquah Real Estate Agent',
    intro:
      "Issaquah sits at the Eastside's doorstep — strong schools, outdoor access to the Cascades, and heavy demand from Microsoft and Costco employees. Pricing runs premium for the Eastside suburb feel.",
    neighborhoods: ['Issaquah Highlands', 'Squak Mountain', 'Talus', 'Downtown Issaquah', 'Klahanie'],
    highlights: [
      'Issaquah School District — top-rated statewide',
      'Tech-employer buyer pool',
      'Issaquah Highlands master-planned community',
      'Trail and outdoor recreation access',
    ],
    whyHere:
      "Issaquah sellers benefit from strong school-district demand. Buyers need to read competing offers carefully — multi-offer situations are common on well-priced homes.",
    heroImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80',
  },

  sammamish: {
    slug: 'sammamish-real-estate-agent',
    name: 'Sammamish',
    county: 'King County',
    lat: 47.6163,
    lng: -122.0356,
    title: 'Sammamish Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Sammamish real estate agent. Top Eastside schools, executive pricing. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Sammamish Real Estate Agent',
    intro:
      "Sammamish is one of the highest-priced residential cities in Washington, driven by top-tier schools and proximity to Microsoft. Pricing discipline matters — overpricing kills deals and underpricing leaves six figures on the table.",
    neighborhoods: ['Sammamish Plateau', 'Trossachs', 'Pine Lake', 'Inglewood', 'Eastlake'],
    highlights: [
      'Lake Washington and Issaquah School Districts',
      'Microsoft-adjacent buyer demand',
      'Executive-tier housing stock',
      'Sammamish River Trail access',
    ],
    whyHere:
      "Sammamish homes sell fast when priced right and sit when they're not. Precise CMA and marketing matter here. Buyers need to move quickly with strong financing.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },

  redmond: {
    slug: 'redmond-real-estate-agent',
    name: 'Redmond',
    county: 'King County',
    lat: 47.6740,
    lng: -122.1215,
    title: 'Redmond Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Redmond WA real estate agent. Microsoft HQ, Education Hill, downtown Redmond. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Redmond Real Estate Agent',
    intro:
      "Redmond is synonymous with Microsoft, and the real estate market reflects that. Strong international buyer demand, top schools, and walkable town center. Pricing is competitive across condos, townhomes, and single-family homes.",
    neighborhoods: ['Education Hill', 'Grass Lawn', 'Idylwood', 'Downtown Redmond', 'Overlake'],
    highlights: [
      'Lake Washington School District',
      'Microsoft campus access',
      'Townhome and single-family mix',
      'Strong buyer pool from global tech relocations',
    ],
    whyHere:
      "Redmond inventory turns over faster than comparable Seattle neighborhoods — but offers are often all-cash or high-down. Buyers need strong positioning; sellers need precise pricing.",
    heroImage: 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=1600&q=80',
  },

  kirkland: {
    slug: 'kirkland-real-estate-agent',
    name: 'Kirkland',
    county: 'King County',
    lat: 47.6815,
    lng: -122.2087,
    title: 'Kirkland Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Kirkland real estate agent. Lake Washington waterfront, downtown Kirkland, Juanita. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Kirkland Real Estate Agent',
    intro:
      "Kirkland combines walkable downtown charm with Lake Washington waterfront. It attracts tech money, downsizers from larger Eastside homes, and families drawn to the Lake Washington School District.",
    neighborhoods: ['Downtown Kirkland', 'Houghton', 'Juanita', 'Rose Hill', 'Kingsgate', 'Totem Lake'],
    highlights: [
      'Lake Washington School District',
      'Lake Washington waterfront inventory',
      'Downtown walkability + restaurant scene',
      'Strong condo and townhome market',
    ],
    whyHere:
      "Kirkland rewards buyers who understand the submarket differences — downtown is a different animal than Juanita or Rose Hill. I help clients read those distinctions correctly.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  'mercer-island': {
    slug: 'mercer-island-real-estate-agent',
    name: 'Mercer Island',
    county: 'King County',
    lat: 47.5707,
    lng: -122.2221,
    title: 'Mercer Island Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Mercer Island real estate agent. Waterfront, executive homes, top schools. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Mercer Island Real Estate Agent',
    intro:
      "Mercer Island is its own island between Seattle and Bellevue — exclusive, small, and expensive. Tight inventory, top schools, and waterfront inventory that rarely lists publicly. This is a precision market.",
    neighborhoods: ['North End', 'South End', 'First Hill', 'East Seattle', 'Mercerwood'],
    highlights: [
      'Mercer Island School District',
      'Lake Washington waterfront expertise',
      'Executive and luxury-tier pricing',
      'Off-market and pocket-listing network',
    ],
    whyHere:
      "Mercer Island often trades through relationships before hitting MLS. Market knowledge and network matter as much as pricing. I help clients access what doesn't show up in portals.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },

  burien: {
    slug: 'burien-real-estate-agent',
    name: 'Burien',
    county: 'King County',
    lat: 47.4704,
    lng: -122.3466,
    title: 'Burien Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Burien real estate agent. Three Tree Point waterfront, Highline Schools, Seattle airport adjacent. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Burien Real Estate Agent',
    intro:
      "Burien balances South King affordability with Puget Sound access. Three Tree Point offers waterfront, while Gregory Heights and downtown deliver value for buyers priced out of West Seattle.",
    neighborhoods: ['Three Tree Point', 'Gregory Heights', 'Boulevard Park', 'Manhattan', 'Seahurst'],
    highlights: [
      'Highline School District',
      'Three Tree Point waterfront experience',
      'SeaTac airport commuter access',
      'Strong value per square foot vs West Seattle',
    ],
    whyHere:
      "Burien's pricing is climbing as Seattle buyers head south. Early movers benefit. Sellers need marketing that reaches Seattle-commuter buyer pool.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  seatac: {
    slug: 'seatac-real-estate-agent',
    name: 'SeaTac',
    county: 'King County',
    lat: 47.4436,
    lng: -122.3016,
    title: 'SeaTac Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'SeaTac WA real estate agent. Airport-adjacent value, investment property, short-term rental. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'SeaTac Real Estate Agent',
    intro:
      "SeaTac offers some of the most accessible pricing in King County, driven by airport proximity. It's a strong investment and first-time buyer market, with short-term rental demand near the airport.",
    neighborhoods: ['McMicken Heights', 'Angle Lake', 'Riverton Heights', 'Bow Lake'],
    highlights: [
      'Highline School District',
      'Short-term rental investment potential',
      'Light rail access to downtown Seattle',
      'Lowest entry price in King County for single-family',
    ],
    whyHere:
      "SeaTac attracts investors and first-time buyers. Know the noise contours, flight paths, and zoning before offering — these variables matter here more than elsewhere.",
    heroImage: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1600&q=80',
  },

  'maple-valley': {
    slug: 'maple-valley-real-estate-agent',
    name: 'Maple Valley',
    county: 'King County',
    lat: 47.3959,
    lng: -122.0448,
    title: 'Maple Valley Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Maple Valley WA real estate agent. Family community, strong schools, Lake Wilderness. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Maple Valley Real Estate Agent',
    intro:
      "Maple Valley draws families seeking space and strong schools within King County — without the full Eastside price tag. Lake Wilderness is the signature location; newer subdivisions fill the rest.",
    neighborhoods: ['Lake Wilderness', 'Lake Sawyer border', 'Summit Place', 'Witte Road corridor'],
    highlights: [
      'Tahoma School District',
      'Lake Wilderness waterfront experience',
      'Newer construction inventory',
      'Commuter access to Bellevue and Renton',
    ],
    whyHere:
      "Maple Valley pricing tracks Tahoma School District demand. Inventory is steady; turnover driven by family lifecycle more than investor activity. I help clients match home size to long-term plans.",
    heroImage: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=80',
  },

  enumclaw: {
    slug: 'enumclaw-real-estate-agent',
    name: 'Enumclaw',
    county: 'King County',
    lat: 47.2043,
    lng: -121.9915,
    title: 'Enumclaw Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Enumclaw WA real estate agent. Rural King County, mountain views, acreage. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Enumclaw Real Estate Agent',
    intro:
      "Enumclaw is King County's rural end — Mount Rainier views, acreage, and a small-town feel without leaving the county. Buyers here want space and nature access; sellers need marketing that reaches that specific audience.",
    neighborhoods: ['Downtown Enumclaw', 'Cumberland', 'Black Diamond border', 'Buckley corridor'],
    highlights: [
      'Enumclaw School District',
      'Acreage and horse property specialist knowledge',
      'Mount Rainier view properties',
      'USDA-eligible financing on many rural properties',
    ],
    whyHere:
      "Enumclaw rewards buyers who want the lifestyle — space, views, quiet. Sellers benefit from an agent who can articulate that appeal to the right buyer pool.",
    heroImage: 'https://images.unsplash.com/photo-1685841295958-2695cbed9093?w=1600&q=80',
  },

  covington: {
    slug: 'covington-real-estate-agent',
    name: 'Covington',
    county: 'King County',
    lat: 47.3570,
    lng: -122.1165,
    title: 'Covington Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Covington WA real estate agent. Family community, Kent-Meridian schools, newer subdivisions. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Covington Real Estate Agent',
    intro:
      "Covington is a newer South King suburb — planned communities, family-sized lots, and commuter access to Bellevue, Renton, and Kent. It offers King County address at price points closer to Pierce.",
    neighborhoods: ['Timberlane', 'Meridian Valley', 'Pipe Lake', 'Covington Place'],
    highlights: [
      'Kent and Tahoma School District coverage',
      'Newer construction inventory',
      'Family-focused community planning',
      'Value per square foot vs Bellevue or Issaquah',
    ],
    whyHere:
      "Covington suits buyers who want King County schools and amenities without top-tier pricing. Inventory is steady; deals reward preparation more than speed.",
    heroImage: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1600&q=80',
  },

  bremerton: {
    slug: 'bremerton-real-estate-agent',
    name: 'Bremerton',
    county: 'Kitsap County',
    lat: 47.5673,
    lng: -122.6329,
    title: 'Bremerton Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Bremerton WA real estate agent. Naval base adjacent, ferry commuter, Kitsap peninsula. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Bremerton Real Estate Agent',
    intro:
      "Bremerton is the Kitsap Peninsula's largest city — strong Navy presence, ferry access to Seattle, and some of the best value in the Puget Sound region. Military VA buyers and Seattle-commuter buyers anchor demand.",
    neighborhoods: ['Downtown Bremerton', 'Manette', 'Rocky Point', 'Kitsap Lake', 'West Bremerton'],
    highlights: [
      'Bremerton and Central Kitsap School Districts',
      'Naval Base Kitsap / VA loan expertise',
      'Ferry commuter market to Seattle',
      'Significantly lower pricing vs King County',
    ],
    whyHere:
      "Bremerton's value proposition is strong — half the price of comparable Seattle or Bellevue homes. Ferry times matter; I help clients weigh commute vs savings correctly.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  'bainbridge-island': {
    slug: 'bainbridge-island-real-estate-agent',
    name: 'Bainbridge Island',
    county: 'Kitsap County',
    lat: 47.6262,
    lng: -122.5210,
    title: 'Bainbridge Island Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Bainbridge Island real estate agent. Ferry commute to Seattle, waterfront, top schools. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Bainbridge Island Real Estate Agent',
    intro:
      "Bainbridge Island is the Kitsap Peninsula's premium destination — 35-minute ferry from downtown Seattle, top schools, waterfront homes, and strong arts community. Pricing runs higher than most of Kitsap, justifiably.",
    neighborhoods: ['Winslow', 'Rolling Bay', 'Lynwood Center', 'Eagle Harbor', 'Port Madison'],
    highlights: [
      'Bainbridge Island School District',
      'Waterfront and view property experience',
      'Seattle ferry commuter market',
      'Executive-tier pricing with strong resale',
    ],
    whyHere:
      "Bainbridge inventory is tight and pricing precise. A careful CMA matters — the island has distinct submarkets with different value drivers. I help clients read them correctly.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  poulsbo: {
    slug: 'poulsbo-real-estate-agent',
    name: 'Poulsbo',
    county: 'Kitsap County',
    lat: 47.7362,
    lng: -122.6461,
    title: 'Poulsbo Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Poulsbo WA real estate agent. Little Norway on the Sound, waterfront, family community. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Poulsbo Real Estate Agent',
    intro:
      "Poulsbo — often called 'Little Norway on the Sound' — blends waterfront village charm with strong schools and family-oriented neighborhoods. It's Kitsap's answer to Gig Harbor.",
    neighborhoods: ['Downtown Poulsbo', 'Lincoln Hill', 'Liberty Bay', 'Suquamish border'],
    highlights: [
      'North Kitsap School District',
      'Liberty Bay waterfront transactions',
      'Strong retiree and family buyer pool',
      'Naval Base Kitsap-Bangor proximity',
    ],
    whyHere:
      "Poulsbo attracts buyers drawn to the village atmosphere. Waterfront and view premiums are real — understanding lot-by-lot value variation matters here.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  silverdale: {
    slug: 'silverdale-real-estate-agent',
    name: 'Silverdale',
    county: 'Kitsap County',
    lat: 47.6447,
    lng: -122.6949,
    title: 'Silverdale Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Silverdale WA real estate agent. Central Kitsap retail hub, Navy-adjacent, newer homes. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Silverdale Real Estate Agent',
    intro:
      "Silverdale is Central Kitsap's retail and service hub — Kitsap Mall, newer residential developments, and strong Navy buyer presence. It offers value and convenience without the ferry.",
    neighborhoods: ['Ridgetop', 'Island Lake', 'Clear Creek', 'Silverdale Beach'],
    highlights: [
      'Central Kitsap School District',
      'Naval Base Kitsap-Bangor proximity',
      'Newer residential subdivisions',
      'Retail and medical service hub',
    ],
    whyHere:
      "Silverdale offers a complete-community feel at Kitsap prices. Navy cycles drive consistent demand. Buyers get more home for the money than most Puget Sound markets.",
    heroImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80',
  },

  'kitsap-county': {
    slug: 'kitsap-county-real-estate-agent',
    name: 'Kitsap County',
    county: 'Kitsap County',
    lat: 47.6437,
    lng: -122.6408,
    title: 'Kitsap County Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Kitsap County real estate agent serving Bremerton, Bainbridge, Poulsbo, Silverdale. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Kitsap County Real Estate Agent',
    intro:
      "Kitsap County sits across the Puget Sound from Seattle — ferry-connected, Navy-anchored, and increasingly popular with buyers priced out of King County. I cover every Kitsap submarket.",
    neighborhoods: ['Bremerton', 'Bainbridge Island', 'Poulsbo', 'Silverdale', 'Port Orchard', 'Kingston', 'Suquamish'],
    highlights: [
      'Full Kitsap County transaction experience',
      'Navy / VA loan expertise',
      'Seattle ferry commuter market knowledge',
      'Waterfront specialist across multiple submarkets',
    ],
    whyHere:
      "Kitsap offers value Seattle and Bellevue can't match. Ferry schedules, Navy cycles, and submarket nuance make local expertise non-negotiable.",
    heroImage: 'https://images.unsplash.com/photo-1685841295958-2695cbed9093?w=1600&q=80',
  },

  tumwater: {
    slug: 'tumwater-real-estate-agent',
    name: 'Tumwater',
    county: 'Thurston County',
    lat: 46.9987,
    lng: -122.9093,
    title: 'Tumwater Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Tumwater WA real estate agent. Brewery District, Tumwater Hill, Thurston County. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Tumwater Real Estate Agent',
    intro:
      "Tumwater offers Olympia-area lifestyle at a softer price point. Strong schools, community character, and steady state-employee buyer demand.",
    neighborhoods: ['Tumwater Hill', 'Brewery District', 'Black Lake', 'Bush Prairie', 'Littlerock corridor'],
    highlights: [
      'Tumwater School District expertise',
      'Historic Brewery District character homes',
      'State-employee buyer pool',
      'Slower-paced market vs Pierce/King',
    ],
    whyHere:
      "Tumwater transactions move deliberately, not frantically. Patience and disciplined pricing work here.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  frederickson: {
    slug: 'frederickson-real-estate-agent',
    name: 'Frederickson',
    county: 'Pierce County',
    lat: 47.0829,
    lng: -122.3582,
    title: 'Frederickson Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Frederickson WA real estate agent. Newer construction, large lots, Bethel schools. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Frederickson Real Estate Agent',
    intro:
      "Frederickson is one of south Pierce County's fastest-growing communities. Newer subdivisions, large lots, and Bethel School District access make it a popular choice for families and JBLM-adjacent buyers.",
    neighborhoods: ['Chambers Creek Canyon', 'Thun Field', 'Canyon Creek', 'Prairie Heights'],
    highlights: ['Bethel School District', 'Newer construction inventory', 'JBLM and VA loan market', 'Large family-sized lots'],
    whyHere: "Frederickson pricing is climbing as south Pierce grows. Buyers get more square footage for the money than Puyallup or Lakewood. Sellers benefit from strong demand on well-maintained homes.",
    heroImage: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=80',
  },

  parkland: {
    slug: 'parkland-real-estate-agent',
    name: 'Parkland',
    county: 'Pierce County',
    lat: 47.1451,
    lng: -122.4337,
    title: 'Parkland Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Parkland WA real estate agent. Value-oriented Pierce County community, PLU nearby. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Parkland Real Estate Agent',
    intro:
      "Parkland sits between Tacoma and Spanaway — home to Pacific Lutheran University and a mix of established residential blocks and newer developments. Strong value play for first-time buyers.",
    neighborhoods: ['PLU area', 'Midland border', 'Spanaway Lake area', 'Brookdale'],
    highlights: ['Franklin Pierce School District', 'Pacific Lutheran University proximity', 'Entry-level pricing', 'Strong rental demand'],
    whyHere: "Parkland is a value market. Investors and first-time buyers compete; owner-occupants need sharp agents to win against all-cash offers.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  orting: {
    slug: 'orting-real-estate-agent',
    name: 'Orting',
    county: 'Pierce County',
    lat: 47.0956,
    lng: -122.2043,
    title: 'Orting Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Orting WA real estate agent. Small-town charm, Mount Rainier views, rural Pierce County. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Orting Real Estate Agent',
    intro:
      "Orting offers the clearest Mount Rainier views in Pierce County, genuine small-town feel, and rural acreage options. Popular with buyers prioritizing space and scenery over commute time.",
    neighborhoods: ['Downtown Orting', 'Carbon River area', 'Calistoga', 'Rainier View'],
    highlights: ['Orting School District', 'Mount Rainier view properties', 'Acreage and horse-property inventory', 'Rural character'],
    whyHere: "Orting rewards buyers who want lifestyle over convenience. Commutes are real; views and lot sizes compensate.",
    heroImage: 'https://images.unsplash.com/photo-1685841295958-2695cbed9093?w=1600&q=80',
  },

  buckley: {
    slug: 'buckley-real-estate-agent',
    name: 'Buckley',
    county: 'Pierce County',
    lat: 47.1634,
    lng: -122.0268,
    title: 'Buckley Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Buckley WA real estate agent. Rural east Pierce, Mount Rainier gateway, acreage. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Buckley Real Estate Agent',
    intro:
      "Buckley anchors east Pierce County near the Mount Rainier approach — historic downtown, larger lots, and rural lifestyle without full remoteness. Draws nature-oriented buyers.",
    neighborhoods: ['Downtown Buckley', 'South Prairie border', 'Lake Tapps access', 'Ryan Road area'],
    highlights: ['White River School District', 'Mount Rainier recreation access', 'Acreage and horse properties', 'Historic downtown character'],
    whyHere: "Buckley pricing trails urban Pierce. Buyers get significantly more land for the money; sellers need marketing to the right outdoor-oriented buyer pool.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  eatonville: {
    slug: 'eatonville-real-estate-agent',
    name: 'Eatonville',
    county: 'Pierce County',
    lat: 46.8654,
    lng: -122.2677,
    title: 'Eatonville Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Eatonville WA real estate agent. Rural south Pierce, Mount Rainier gateway, USDA eligible. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Eatonville Real Estate Agent',
    intro:
      "Eatonville sits at the southern gateway to Mount Rainier National Park — small-town feel, acreage, and many properties that qualify for USDA financing. Strong appeal to remote workers and nature lovers.",
    neighborhoods: ['Downtown Eatonville', 'Ohop Valley', 'Alder Lake area', 'Mashell River'],
    highlights: ['Eatonville School District', 'USDA-eligible financing', 'Mount Rainier recreation', 'Acreage and waterfront inventory'],
    whyHere: "Eatonville is for buyers who want remoteness without isolation. The USDA loan option opens doors for buyers without large down payments.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  milton: {
    slug: 'milton-real-estate-agent',
    name: 'Milton',
    county: 'Pierce County',
    lat: 47.2487,
    lng: -122.3145,
    title: 'Milton Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Milton WA real estate agent. Small commuter city between Tacoma and Federal Way. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Milton Real Estate Agent',
    intro:
      "Milton is a small city straddling the Pierce-King line — commuter-friendly, quiet residential blocks, and value pricing relative to Federal Way and Fife.",
    neighborhoods: ['Downtown Milton', 'Surprise Lake', 'Hylebos Wetlands area', 'Edgewood border'],
    highlights: ['Fife School District', 'Commuter access to Seattle, Tacoma, Kent', 'Value vs Federal Way', 'Quiet residential character'],
    whyHere: "Milton flies under the radar — which is why pricing lags neighboring cities. Opportunity for value-focused buyers.",
    heroImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80',
  },

  shoreline: {
    slug: 'shoreline-real-estate-agent',
    name: 'Shoreline',
    county: 'King County',
    lat: 47.7557,
    lng: -122.3415,
    title: 'Shoreline Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Shoreline WA real estate agent. North Seattle-adjacent, top schools, light rail coming. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Shoreline Real Estate Agent',
    intro:
      "Shoreline sits directly north of Seattle — family neighborhoods, top schools, and Sound Transit light rail bringing new demand. A growing favorite for buyers priced out of Seattle proper.",
    neighborhoods: ['Richmond Beach', 'Ballinger', 'Briarcrest', 'Innis Arden', 'North City', 'Shoreline Center'],
    highlights: ['Shoreline School District — top-rated', 'Sound Transit light rail stations', 'Seattle-adjacent value', 'Strong craftsman and mid-century stock'],
    whyHere: "Shoreline pricing is climbing as light rail expands. Early buyers benefit from ongoing appreciation; sellers benefit from expanding buyer pool.",
    heroImage: 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=1600&q=80',
  },

  newcastle: {
    slug: 'newcastle-real-estate-agent',
    name: 'Newcastle',
    county: 'King County',
    lat: 47.5301,
    lng: -122.1651,
    title: 'Newcastle Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Newcastle WA real estate agent. Eastside hilltop community, view homes, top schools. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Newcastle Real Estate Agent',
    intro:
      "Newcastle perches on the hills between Bellevue and Renton — top-tier views, Issaquah School District access, and executive-tier pricing in the Lake Boren and Coal Creek areas.",
    neighborhoods: ['Lake Boren', 'Coal Creek', 'Olympus', 'China Creek', 'Golf Course area'],
    highlights: ['Issaquah and Renton School Districts', 'Lake Washington and Seattle views', 'Executive-tier single-family stock', 'Golf course community'],
    whyHere: "Newcastle inventory is thin and view homes command serious premiums. Precise CMA matters — comps vary by block and view direction.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },

  woodinville: {
    slug: 'woodinville-real-estate-agent',
    name: 'Woodinville',
    county: 'King County',
    lat: 47.7540,
    lng: -122.1635,
    title: 'Woodinville Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Woodinville WA real estate agent. Wine country, large lots, Northshore schools. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Woodinville Real Estate Agent',
    intro:
      "Woodinville is Seattle's wine country — 100+ tasting rooms, larger semi-rural lots, and top schools. Draws affluent buyers wanting space with Eastside employer access.",
    neighborhoods: ['Downtown Woodinville', 'Hollywood Hill', 'Wellington', 'Cottage Lake', 'Tourist District'],
    highlights: ['Northshore School District', 'Woodinville wine district', 'Larger semi-rural lots', 'Eastside tech employer access'],
    whyHere: "Woodinville attracts buyers willing to pay for lifestyle — acreage, wine country, and schools. Pricing is firm; competition strong on well-priced homes.",
    heroImage: 'https://images.unsplash.com/photo-1685841295958-2695cbed9093?w=1600&q=80',
  },

  duvall: {
    slug: 'duvall-real-estate-agent',
    name: 'Duvall',
    county: 'King County',
    lat: 47.7423,
    lng: -121.9853,
    title: 'Duvall Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Duvall WA real estate agent. Small-town charm, Snoqualmie Valley views, Riverview schools. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Duvall Real Estate Agent',
    intro:
      "Duvall is a small town in the Snoqualmie Valley — historic downtown, valley views, and strong family community. A rural King County option for buyers willing to commute.",
    neighborhoods: ['Downtown Duvall', 'Cherry Valley', 'Tolt Highlands', 'Big Rock'],
    highlights: ['Riverview School District', 'Snoqualmie Valley views', 'Small-town community feel', 'Larger lots than urban King'],
    whyHere: "Duvall pricing is below urban King County. Trade-off is commute length to Bellevue or Seattle. Valley views compensate.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  'north-bend': {
    slug: 'north-bend-real-estate-agent',
    name: 'North Bend',
    county: 'King County',
    lat: 47.4960,
    lng: -121.7869,
    title: 'North Bend Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'North Bend WA real estate agent. Mountain gateway, mountain views, Snoqualmie Valley. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'North Bend Real Estate Agent',
    intro:
      "North Bend is the Cascade foothills gateway — Mount Si views, outdoor recreation access, and historic main street. Strong demand from remote workers and Seattle commuters seeking nature.",
    neighborhoods: ['Downtown North Bend', 'Mount Si area', 'Tanner', 'Opstad', 'Si View'],
    highlights: ['Snoqualmie Valley School District', 'Mount Si and I-90 recreation access', 'Mountain view inventory', 'Outlet mall and downtown walkability'],
    whyHere: "North Bend has boomed with remote work. Pricing has climbed but still offers value vs Issaquah or Sammamish for mountain-oriented buyers.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  snoqualmie: {
    slug: 'snoqualmie-real-estate-agent',
    name: 'Snoqualmie',
    county: 'King County',
    lat: 47.5301,
    lng: -121.8254,
    title: 'Snoqualmie Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Snoqualmie WA real estate agent. Snoqualmie Ridge master-planned community, mountain views. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Snoqualmie Real Estate Agent',
    intro:
      "Snoqualmie Ridge is the master-planned community that defines this city — newer construction, walkable amenities, top schools, and strong tech-employer buyer demand.",
    neighborhoods: ['Snoqualmie Ridge', 'Historic Snoqualmie', 'Echo Ridge', 'Ridgewood'],
    highlights: ['Snoqualmie Valley School District', 'Master-planned community amenities', 'Newer construction inventory', 'Cascade foothills access'],
    whyHere: "Snoqualmie rewards buyers who want newer construction with community planning. Inventory turns over with tech relocation cycles.",
    heroImage: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80',
  },

  tukwila: {
    slug: 'tukwila-real-estate-agent',
    name: 'Tukwila',
    county: 'King County',
    lat: 47.4742,
    lng: -122.2607,
    title: 'Tukwila Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Tukwila WA real estate agent. South King value, Westfield Southcenter, airport adjacent. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Tukwila Real Estate Agent',
    intro:
      "Tukwila combines South King pricing with retail/employment anchors — Westfield Southcenter, airport access, and light rail. Strong investor and first-time buyer market.",
    neighborhoods: ['Southcenter area', 'Tukwila Hill', 'Riverton Heights border', 'Allentown'],
    highlights: ['Tukwila and Highline School Districts', 'Sound Transit light rail', 'Retail and employment hub', 'Entry-level King County pricing'],
    whyHere: "Tukwila competes on price and location. Inventory moves fast when priced correctly; investors and occupants both compete.",
    heroImage: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1600&q=80',
  },

  kenmore: {
    slug: 'kenmore-real-estate-agent',
    name: 'Kenmore',
    county: 'King County',
    lat: 47.7573,
    lng: -122.2440,
    title: 'Kenmore Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Kenmore WA real estate agent. North Lake Washington, Northshore schools, waterfront. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Kenmore Real Estate Agent',
    intro:
      "Kenmore anchors the north end of Lake Washington — waterfront access, Northshore School District, and easier pricing than Kirkland or Bellevue. Quiet family community.",
    neighborhoods: ['Lakepointe', 'Inglewood', 'Arrowhead', 'Uplake', 'Moorlands'],
    highlights: ['Northshore School District', 'Lake Washington waterfront', 'Commute to Bellevue and Bothell employers', 'Kenmore Air seaplane access'],
    whyHere: "Kenmore offers lake-adjacent pricing at a discount to Kirkland. Waterfront homes command premiums; inland homes trade on schools and commute.",
    heroImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=1600&q=80',
  },

  yelm: {
    slug: 'yelm-real-estate-agent',
    name: 'Yelm',
    county: 'Thurston County',
    lat: 46.9424,
    lng: -122.6057,
    title: 'Yelm Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Yelm WA real estate agent. Rural Thurston County, JBLM commute, USDA eligible. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Yelm Real Estate Agent',
    intro:
      "Yelm offers rural character with JBLM commute access — affordable pricing, larger lots, and Yelm School District. Military families and first-time buyers anchor demand.",
    neighborhoods: ['Downtown Yelm', 'Rainier border', 'Lake Lawrence', 'McKenna'],
    highlights: ['Yelm School District', 'JBLM commute market', 'USDA-eligible financing', 'Larger lots and rural feel'],
    whyHere: "Yelm prices significantly below urban Pierce or Thurston. Commute matters — I help clients weigh trade-offs correctly.",
    heroImage: 'https://images.unsplash.com/photo-1685841295958-2695cbed9093?w=1600&q=80',
  },

  tenino: {
    slug: 'tenino-real-estate-agent',
    name: 'Tenino',
    county: 'Thurston County',
    lat: 46.8571,
    lng: -122.8543,
    title: 'Tenino Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Tenino WA real estate agent. Small-town Thurston County, sandstone quarry history. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Tenino Real Estate Agent',
    intro:
      "Tenino is a historic small town south of Olympia — quiet, affordable, with genuine community feel. Rural character without full remoteness.",
    neighborhoods: ['Downtown Tenino', 'Scatter Creek area', 'Skookumchuck River area'],
    highlights: ['Tenino School District', 'Historic downtown character', 'Rural community feel', 'Lowest Thurston County pricing'],
    whyHere: "Tenino is for buyers who want small-town quality of life. Limited inventory means patience matters.",
    heroImage: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1600&q=80',
  },

  'port-orchard': {
    slug: 'port-orchard-real-estate-agent',
    name: 'Port Orchard',
    county: 'Kitsap County',
    lat: 47.5404,
    lng: -122.6361,
    title: 'Port Orchard Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Port Orchard WA real estate agent. Kitsap peninsula, Navy-adjacent, waterfront value. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Port Orchard Real Estate Agent',
    intro:
      "Port Orchard sits across Sinclair Inlet from Bremerton — Navy-adjacent, historic downtown, and strong waterfront inventory. One of Kitsap's best value markets.",
    neighborhoods: ['Downtown Port Orchard', 'Sidney', 'Manchester', 'Olalla', 'McCormick Woods'],
    highlights: ['South Kitsap School District', 'Naval Base Kitsap access', 'Waterfront and view homes', 'Strong value vs Bainbridge or Silverdale'],
    whyHere: "Port Orchard trades well below Bainbridge for similar water access. Buyers get more home for the money; sellers benefit from growing demand.",
    heroImage: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=80',
  },

  kingston: {
    slug: 'kingston-real-estate-agent',
    name: 'Kingston',
    county: 'Kitsap County',
    lat: 47.7971,
    lng: -122.4969,
    title: 'Kingston Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Kingston WA real estate agent. Kitsap ferry community, waterfront, Edmonds ferry access. Mazen El-Majzoub. (253) 315-9480.',
    headline: 'Kingston Real Estate Agent',
    intro:
      "Kingston anchors north Kitsap with ferry service to Edmonds — smaller, quieter, and priced below Bainbridge while offering similar ferry-commute appeal.",
    neighborhoods: ['Downtown Kingston', 'Apple Tree Cove', 'Port Gamble Bay', 'Hansville corridor'],
    highlights: ['North Kitsap School District', 'Kingston-Edmonds ferry', 'Waterfront and view inventory', 'Value vs Bainbridge Island'],
    whyHere: "Kingston is Bainbridge's quieter cousin at a lower price point. Ferry buyers comparing both often choose Kingston for the savings.",
    heroImage: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1600&q=80',
  },

  'black-diamond': {
    slug: 'black-diamond-real-estate-agent',
    name: 'Black Diamond',
    county: 'King County',
    lat: 47.3087,
    lng: -122.0032,
    title: 'Black Diamond Real Estate Agent | Mazen El-Majzoub',
    metaDescription:
      'Black Diamond WA real estate agent. Ten Trails new construction, historic homes, and King County expertise. Mazen El-Majzoub. Call (253) 315-9480.',
    headline: 'Black Diamond Real Estate Agent',
    intro:
      "Black Diamond has transformed — from a quiet historic town into one of King County's fastest-growing master-planned communities. I help buyers navigate Ten Trails inventory and sellers in established Black Diamond neighborhoods reach the right buyer pool.",
    neighborhoods: ['Ten Trails', 'Downtown Black Diamond', 'Lake Sawyer', 'Jones Lake', 'Enumclaw border'],
    highlights: [
      'Ten Trails master-planned community expertise',
      'Enumclaw School District knowledge',
      'New construction negotiation experience with regional builders',
      'Lake Sawyer waterfront transaction knowledge',
    ],
    whyHere:
      "Black Diamond's growth is real, but pricing varies wildly between new builds and resale stock. I help clients understand the difference — and make buying or selling decisions based on actual comps, not builder marketing.",
    heroImage: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=1600&q=80',
  },
};

export const cityList = Object.values(cities);
